import { ScreenTemplate } from '../interfaces/template.models';

/**
 * Template de Cadastro de Produtos
 */
export const PRODUCT_TEMPLATE: ScreenTemplate = {
  id: 'product-cadastro',
  name: 'Cadastro de Produtos',
  description: 'Template para cadastro de produtos com campos essenciais',
  category: 'product',
  gridConfig: { columns: 24, rows: 15, gap: '16px' },
  components: [
    {
      type: 'text',
      props: {
        label: 'product.name',
        placeholder: 'product.name.placeholder',
        required: true,
        rowSpan: 1,
        colSpan: 24, // Ocupa toda a largura
      },
      position: { row: 0, col: 0, rowSpan: 1, colSpan: 24 },
    },
    {
      type: 'textarea',
      props: {
        label: 'product.description',
        placeholder: 'product.description.placeholder',
        rowSpan: 2, // Ocupa 2 linhas para descrição
        colSpan: 24,
      },
      position: { row: 1, col: 0, rowSpan: 2, colSpan: 24 },
    },
    {
      type: 'number',
      props: {
        label: 'product.price',
        placeholder: 'product.price.placeholder',
        required: true,
        rowSpan: 1,
        colSpan: 12, // Metade da largura (esquerda)
      },
      position: { row: 3, col: 0, rowSpan: 1, colSpan: 12 },
    },
    {
      type: 'number',
      props: {
        label: 'product.stock',
        placeholder: 'product.stock.placeholder',
        required: true,
        rowSpan: 1,
        colSpan: 12, // Metade da largura (direita)
      },
      position: { row: 3, col: 12, rowSpan: 1, colSpan: 12 },
    },
    {
      type: 'text',
      props: {
        label: 'product.category',
        placeholder: 'product.category.placeholder',
        required: true,
        rowSpan: 1,
        colSpan: 16, // 2/3 da largura
      },
      position: { row: 4, col: 0, rowSpan: 1, colSpan: 16 },
    },
    {
      type: 'switch',
      props: {
        label: 'product.active',
        checkedChildren: 'product.active.yes',
        unCheckedChildren: 'product.active.no',
        rowSpan: 1,
        colSpan: 8, // 1/3 da largura
      },
      position: { row: 4, col: 16, rowSpan: 1, colSpan: 8 },
    },
    {
      type: 'text',
      props: {
        label: 'product.sku',
        placeholder: 'product.sku.placeholder',
        required: true,
        rowSpan: 1,
        colSpan: 12, // SKU na esquerda
      },
      position: { row: 5, col: 0, rowSpan: 1, colSpan: 12 },
    },
    {
      type: 'text',
      props: {
        label: 'product.brand',
        placeholder: 'product.brand.placeholder',
        required: false,
        rowSpan: 1,
        colSpan: 12, // Marca na direita
      },
      position: { row: 5, col: 12, rowSpan: 1, colSpan: 12 },
    },
    {
      type: 'number',
      props: {
        label: 'product.weight',
        placeholder: 'product.weight.placeholder',
        required: false,
        rowSpan: 1,
        colSpan: 8, // Peso
      },
      position: { row: 6, col: 0, rowSpan: 1, colSpan: 8 },
    },
    {
      type: 'text',
      props: {
        label: 'product.dimensions',
        placeholder: 'product.dimensions.placeholder',
        required: false,
        rowSpan: 1,
        colSpan: 8, // Dimensões
      },
      position: { row: 6, col: 8, rowSpan: 1, colSpan: 8 },
    },
    {
      type: 'text',
      props: {
        label: 'product.color',
        placeholder: 'product.color.placeholder',
        required: false,
        rowSpan: 1,
        colSpan: 8, // Cor
      },
      position: { row: 6, col: 16, rowSpan: 1, colSpan: 8 },
    },
    {
      type: 'text',
      props: {
        label: 'product.supplier',
        placeholder: 'product.supplier.placeholder',
        required: false,
        rowSpan: 1,
        colSpan: 16, // Fornecedor
      },
      position: { row: 7, col: 0, rowSpan: 1, colSpan: 16 },
    },
    {
      type: 'number',
      props: {
        label: 'product.minStock',
        placeholder: 'product.minStock.placeholder',
        required: false,
        rowSpan: 1,
        colSpan: 8, // Estoque mínimo
      },
      position: { row: 7, col: 16, rowSpan: 1, colSpan: 8 },
    },
    {
      type: 'textarea',
      props: {
        label: 'product.notes',
        placeholder: 'product.notes.placeholder',
        required: false,
        rowSpan: 2, // Observações
        colSpan: 24,
      },
      position: { row: 8, col: 0, rowSpan: 2, colSpan: 24 },
    },
    {
      type: 'button',
      props: {
        label: 'product.register',
        rowSpan: 1,
        colSpan: 8, // Botão cadastrar
      },
      position: { row: 10, col: 8, rowSpan: 1, colSpan: 8 },
    },
  ],
  createdAt: new Date(),
  updatedAt: new Date(),
};

/**
 * Template de Cadastro de Parceiros
 */
export const PARTNER_TEMPLATE: ScreenTemplate = {
  id: 'partner-cadastro',
  name: 'Cadastro de Parceiros',
  description: 'Template para cadastro de parceiros comerciais',
  category: 'partner',
  gridConfig: { columns: 24, rows: 18, gap: '16px' },
  components: [
    {
      type: 'text',
      props: {
        label: 'partner.name',
        placeholder: 'partner.name.placeholder',
        required: true,
        rowSpan: 1,
        colSpan: 24, // Nome completo ocupa toda largura
      },
      position: { row: 0, col: 0, rowSpan: 1, colSpan: 24 },
    },
    {
      type: 'text',
      props: {
        label: 'partner.cnpj',
        placeholder: 'partner.cnpj.placeholder',
        required: true,
        rowSpan: 1,
        colSpan: 12, // CNPJ na esquerda
      },
      position: { row: 1, col: 0, rowSpan: 1, colSpan: 12 },
    },
    {
      type: 'text',
      props: {
        label: 'partner.type',
        placeholder: 'partner.type.placeholder',
        required: true,
        rowSpan: 1,
        colSpan: 12, // Tipo na direita
      },
      position: { row: 1, col: 12, rowSpan: 1, colSpan: 12 },
    },
    {
      type: 'text',
      props: {
        label: 'partner.email',
        placeholder: 'partner.email.placeholder',
        required: true,
        rowSpan: 1,
        colSpan: 16, // Email ocupa 2/3
      },
      position: { row: 2, col: 0, rowSpan: 1, colSpan: 16 },
    },
    {
      type: 'text',
      props: {
        label: 'partner.phone',
        placeholder: 'partner.phone.placeholder',
        required: false,
        rowSpan: 1,
        colSpan: 8, // Telefone ocupa 1/3
      },
      position: { row: 2, col: 16, rowSpan: 1, colSpan: 8 },
    },
    {
      type: 'text',
      props: {
        label: 'partner.contactPerson',
        placeholder: 'partner.contactPerson.placeholder',
        required: false,
        rowSpan: 1,
        colSpan: 12, // Pessoa de contato
      },
      position: { row: 3, col: 0, rowSpan: 1, colSpan: 12 },
    },
    {
      type: 'text',
      props: {
        label: 'partner.contactPhone',
        placeholder: 'partner.contactPhone.placeholder',
        required: false,
        rowSpan: 1,
        colSpan: 12, // Telefone do contato
      },
      position: { row: 3, col: 12, rowSpan: 1, colSpan: 12 },
    },
    {
      type: 'textarea',
      props: {
        label: 'partner.address',
        placeholder: 'partner.address.placeholder',
        required: true,
        rowSpan: 3, // Endereço ocupa 3 linhas
        colSpan: 24,
      },
      position: { row: 4, col: 0, rowSpan: 3, colSpan: 24 },
    },
    {
      type: 'text',
      props: {
        label: 'partner.city',
        placeholder: 'partner.city.placeholder',
        required: true,
        rowSpan: 1,
        colSpan: 12, // Cidade
      },
      position: { row: 7, col: 0, rowSpan: 1, colSpan: 12 },
    },
    {
      type: 'text',
      props: {
        label: 'partner.state',
        placeholder: 'partner.state.placeholder',
        required: true,
        rowSpan: 1,
        colSpan: 12, // Estado
      },
      position: { row: 7, col: 12, rowSpan: 1, colSpan: 12 },
    },
    {
      type: 'text',
      props: {
        label: 'partner.cep',
        placeholder: 'partner.cep.placeholder',
        required: true,
        rowSpan: 1,
        colSpan: 8, // CEP
      },
      position: { row: 8, col: 0, rowSpan: 1, colSpan: 8 },
    },
    {
      type: 'text',
      props: {
        label: 'partner.country',
        placeholder: 'partner.country.placeholder',
        required: true,
        rowSpan: 1,
        colSpan: 8, // País
      },
      position: { row: 8, col: 8, rowSpan: 1, colSpan: 8 },
    },
    {
      type: 'text',
      props: {
        label: 'partner.website',
        placeholder: 'partner.website.placeholder',
        required: false,
        rowSpan: 1,
        colSpan: 8, // Website
      },
      position: { row: 8, col: 16, rowSpan: 1, colSpan: 8 },
    },
    {
      type: 'number',
      props: {
        label: 'partner.creditLimit',
        placeholder: 'partner.creditLimit.placeholder',
        required: false,
        rowSpan: 1,
        colSpan: 12, // Limite de crédito
      },
      position: { row: 9, col: 0, rowSpan: 1, colSpan: 12 },
    },
    {
      type: 'text',
      props: {
        label: 'partner.paymentTerms',
        placeholder: 'partner.paymentTerms.placeholder',
        required: false,
        rowSpan: 1,
        colSpan: 12, // Condições de pagamento
      },
      position: { row: 9, col: 12, rowSpan: 1, colSpan: 12 },
    },
    {
      type: 'textarea',
      props: {
        label: 'partner.notes',
        placeholder: 'partner.notes.placeholder',
        required: false,
        rowSpan: 2, // Observações
        colSpan: 24,
      },
      position: { row: 10, col: 0, rowSpan: 2, colSpan: 24 },
    },
    {
      type: 'switch',
      props: {
        label: 'partner.active',
        checkedChildren: 'partner.active.yes',
        unCheckedChildren: 'partner.active.no',
        rowSpan: 1,
        colSpan: 8,
      },
      position: { row: 12, col: 0, rowSpan: 1, colSpan: 8 },
    },
    {
      type: 'button',
      props: {
        label: 'partner.register',
        rowSpan: 1,
        colSpan: 8, // Botão cadastrar
      },
      position: { row: 12, col: 8, rowSpan: 1, colSpan: 8 },
    },
  ],
  createdAt: new Date(),
  updatedAt: new Date(),
};

/**
 * Template de Cadastro de Marketplaces
 */
export const MARKETPLACE_TEMPLATE: ScreenTemplate = {
  id: 'marketplace-cadastro',
  name: 'Cadastro de Marketplaces',
  description: 'Template para cadastro de marketplaces',
  category: 'marketplace',
  gridConfig: { columns: 24, rows: 16, gap: '16px' },
  components: [
    {
      type: 'text',
      props: {
        label: 'marketplace.name',
        placeholder: 'marketplace.name.placeholder',
        required: true,
        rowSpan: 1,
        colSpan: 24,
      },
      position: { row: 0, col: 0, rowSpan: 1, colSpan: 24 },
    },
    {
      type: 'text',
      props: {
        label: 'marketplace.url',
        placeholder: 'marketplace.url.placeholder',
        required: true,
        rowSpan: 1,
        colSpan: 16,
      },
      position: { row: 1, col: 0, rowSpan: 1, colSpan: 16 },
    },
    {
      type: 'text',
      props: {
        label: 'marketplace.category',
        placeholder: 'marketplace.category.placeholder',
        required: true,
        rowSpan: 1,
        colSpan: 8,
      },
      position: { row: 1, col: 16, rowSpan: 1, colSpan: 8 },
    },
    {
      type: 'text',
      props: {
        label: 'marketplace.country',
        placeholder: 'marketplace.country.placeholder',
        required: true,
        rowSpan: 1,
        colSpan: 8,
      },
      position: { row: 2, col: 0, rowSpan: 1, colSpan: 8 },
    },
    {
      type: 'text',
      props: {
        label: 'marketplace.currency',
        placeholder: 'marketplace.currency.placeholder',
        required: true,
        rowSpan: 1,
        colSpan: 8,
      },
      position: { row: 2, col: 8, rowSpan: 1, colSpan: 8 },
    },
    {
      type: 'number',
      props: {
        label: 'marketplace.commission',
        placeholder: 'marketplace.commission.placeholder',
        required: true,
        rowSpan: 1,
        colSpan: 8,
      },
      position: { row: 2, col: 16, rowSpan: 1, colSpan: 8 },
    },
    {
      type: 'text',
      props: {
        label: 'marketplace.contactEmail',
        placeholder: 'marketplace.contactEmail.placeholder',
        required: false,
        rowSpan: 1,
        colSpan: 16, // Email de contato
      },
      position: { row: 3, col: 0, rowSpan: 1, colSpan: 16 },
    },
    {
      type: 'text',
      props: {
        label: 'marketplace.contactPhone',
        placeholder: 'marketplace.contactPhone.placeholder',
        required: false,
        rowSpan: 1,
        colSpan: 8, // Telefone de contato
      },
      position: { row: 3, col: 16, rowSpan: 1, colSpan: 8 },
    },
    {
      type: 'textarea',
      props: {
        label: 'marketplace.description',
        placeholder: 'marketplace.description.placeholder',
        required: false,
        rowSpan: 2,
        colSpan: 24,
      },
      position: { row: 4, col: 0, rowSpan: 2, colSpan: 24 },
    },
    {
      type: 'text',
      props: {
        label: 'marketplace.apiKey',
        placeholder: 'marketplace.apiKey.placeholder',
        required: false,
        rowSpan: 1,
        colSpan: 16, // Chave da API
      },
      position: { row: 6, col: 0, rowSpan: 1, colSpan: 16 },
    },
    {
      type: 'text',
      props: {
        label: 'marketplace.apiSecret',
        placeholder: 'marketplace.apiSecret.placeholder',
        required: false,
        rowSpan: 1,
        colSpan: 8, // Segredo da API
      },
      position: { row: 6, col: 16, rowSpan: 1, colSpan: 8 },
    },
    {
      type: 'number',
      props: {
        label: 'marketplace.shippingTime',
        placeholder: 'marketplace.shippingTime.placeholder',
        required: false,
        rowSpan: 1,
        colSpan: 8, // Tempo de envio
      },
      position: { row: 7, col: 0, rowSpan: 1, colSpan: 8 },
    },
    {
      type: 'text',
      props: {
        label: 'marketplace.shippingMethod',
        placeholder: 'marketplace.shippingMethod.placeholder',
        required: false,
        rowSpan: 1,
        colSpan: 8, // Método de envio
      },
      position: { row: 7, col: 8, rowSpan: 1, colSpan: 8 },
    },
    {
      type: 'text',
      props: {
        label: 'marketplace.returnPolicy',
        placeholder: 'marketplace.returnPolicy.placeholder',
        required: false,
        rowSpan: 1,
        colSpan: 8, // Política de devolução
      },
      position: { row: 7, col: 16, rowSpan: 1, colSpan: 8 },
    },
    {
      type: 'textarea',
      props: {
        label: 'marketplace.notes',
        placeholder: 'marketplace.notes.placeholder',
        required: false,
        rowSpan: 2, // Observações
        colSpan: 24,
      },
      position: { row: 8, col: 0, rowSpan: 2, colSpan: 24 },
    },
    {
      type: 'switch',
      props: {
        label: 'marketplace.active',
        checkedChildren: 'marketplace.active.yes',
        unCheckedChildren: 'marketplace.active.no',
        rowSpan: 1,
        colSpan: 8,
      },
      position: { row: 10, col: 0, rowSpan: 1, colSpan: 8 },
    },
    {
      type: 'button',
      props: {
        label: 'marketplace.register',
        rowSpan: 1,
        colSpan: 8, // Botão cadastrar
      },
      position: { row: 10, col: 8, rowSpan: 1, colSpan: 8 },
    },
  ],
  createdAt: new Date(),
  updatedAt: new Date(),
};

/**
 * Template de Multi Marketplaces - Baseado no JSON fornecido
 */
export const MULTI_MARKETPLACES_TEMPLATE: ScreenTemplate = {
  id: 'multi-marketplaces',
  name: 'Multi Marketplaces',
  description: 'Template para gestão de produtos em múltiplos marketplaces',
  category: 'marketplace',
  gridConfig: { columns: 24, rows: 15, gap: '16px' },
  components: [
    // Abas principais baseadas no JSON
    {
      type: 'tabs',
      props: {
        label: 'Multi Marketplaces Tabs',
        rowSpan: 13,
        colSpan: 24,
      },
      position: { row: 0, col: 0, rowSpan: 13, colSpan: 24 },
    },
    
    // Campo: codeproduct (panel: main)
    {
      type: 'text', // Adaptado de "search" para "text" (nosso sistema)
      props: {
        label: 'Cód. Produto',
        placeholder: 'Cód. Produto',
        required: true,
        rowSpan: 1,
        colSpan: 24,
      },
      position: { row: 1, col: 0, rowSpan: 1, colSpan: 24 },
    },
    
    // Campo: usaShopee (panel: main, row: 1, col: 0)
    {
      type: 'switch',
      props: {
        label: 'Shopee',
        placeholder: 'Shopee',
        checkedChildren: 'Ativo',
        unCheckedChildren: 'Inativo',
        rowSpan: 1,
        colSpan: 6,
      },
      position: { row: 2, col: 0, rowSpan: 1, colSpan: 6 },
    },
    
    // Campo: usaMeli (panel: main, row: 1, col: 1)
    {
      type: 'switch',
      props: {
        label: 'Mercado Livre',
        placeholder: 'Mercado Livre',
        checkedChildren: 'Ativo',
        unCheckedChildren: 'Inativo',
        rowSpan: 1,
        colSpan: 6,
      },
      position: { row: 2, col: 6, rowSpan: 1, colSpan: 6 },
    },
    
    // Campo: name (panel: main, row: 2)
    {
      type: 'text',
      props: {
        label: 'Descrição',
        placeholder: 'Descrição',
        required: false,
        rowSpan: 1,
        colSpan: 24,
      },
      position: { row: 3, col: 0, rowSpan: 1, colSpan: 24 },
    },
    
    // Campo: description (panel: main, row: 3)
    {
      type: 'textarea', // Adaptado de "richedtext" para "textarea"
      props: {
        label: 'Descrição Detalhada',
        placeholder: 'Descrição Detalhada',
        required: false,
        rowSpan: 3,
        colSpan: 24,
      },
      position: { row: 4, col: 0, rowSpan: 3, colSpan: 24 },
    },
    
    // Campo: marcas (panel: shopeemain, row: 1)
    {
      type: 'text', // Adaptado de "querySelect" para "text"
      props: {
        label: 'Marcas',
        placeholder: 'Marcas',
        required: false,
        rowSpan: 1,
        colSpan: 24,
      },
      position: { row: 1, col: 0, rowSpan: 1, colSpan: 24 },
    },
    
    // Campos adicionais para Shopee
    {
      type: 'text',
      props: {
        label: 'Categoria Shopee',
        placeholder: 'Categoria Shopee',
        required: false,
        rowSpan: 1,
        colSpan: 12,
      },
      position: { row: 2, col: 0, rowSpan: 1, colSpan: 12 },
    },
    
    {
      type: 'number',
      props: {
        label: 'Preço Shopee',
        placeholder: 'Preço Shopee',
        required: false,
        rowSpan: 1,
        colSpan: 12,
      },
      position: { row: 2, col: 12, rowSpan: 1, colSpan: 12 },
    },
    
    // Campo: melicat (panel: melimain, row: 1)
    {
      type: 'text', // Adaptado de "querySelect" para "text"
      props: {
        label: 'Categorias',
        placeholder: 'Categorias',
        required: false,
        rowSpan: 1,
        colSpan: 24,
      },
      position: { row: 1, col: 0, rowSpan: 1, colSpan: 24 },
    },
    
    // Campos adicionais para Mercado Livre
    {
      type: 'text',
      props: {
        label: 'Tipo de Listagem',
        placeholder: 'Tipo de Listagem',
        required: false,
        rowSpan: 1,
        colSpan: 12,
      },
      position: { row: 2, col: 0, rowSpan: 1, colSpan: 12 },
    },
    
    {
      type: 'number',
      props: {
        label: 'Preço Mercado Livre',
        placeholder: 'Preço Mercado Livre',
        required: false,
        rowSpan: 1,
        colSpan: 12,
      },
      position: { row: 2, col: 12, rowSpan: 1, colSpan: 12 },
    },
    
    // Botões de ação
    {
      type: 'button',
      props: {
        label: 'Salvar',
        rowSpan: 1,
        colSpan: 8,
      },
      position: { row: 13, col: 4, rowSpan: 1, colSpan: 8 },
    },
    
    {
      type: 'button',
      props: {
        label: 'Publicar',
        rowSpan: 1,
        colSpan: 8,
      },
      position: { row: 13, col: 12, rowSpan: 1, colSpan: 8 },
    },
  ],
  createdAt: new Date(),
  updatedAt: new Date(),
};